/*
 * @Author: xiaolong.xu
 * @Date: 2023-08-10 10:15:36
 * @LastEditors: 最后编辑
 * @LastEditTime: 2023-08-24 16:38:02
 * @Description: 会员标识
 */
import React, { memo } from 'react'
import IconSvg from '@/components/IconSvg'
import classNames from 'classnames'
import { useTranslation } from '@/libs/next-lang'
import Dropdown from './Dropdown'
import styles from './index.module.less'

interface Props {
  classNames?: string
  style?: React.CSSProperties
  onClick?: () => void
}

const CustomerService = memo((props: Props) => {
  const { style = {}, onClick = () => {} } = props
  const { t } = useTranslation(['components'])

  const txt: string = t('components:t20')
  return (
    <Dropdown translateTxt={t}>
      <div
        className={classNames(styles['customer-service-wrapper'], {
          [props.classNames]: props.classNames,
        })}
      >
        <div style={style} className="customer-service-content" onClick={onClick}>
          <IconSvg type="icon-assets-kefu" style={{ width: 16 }} />
          <span className="info" title={txt}>
            {txt}
          </span>
          <i
            style={{
              background: '#4E5969',
              display: 'flex',
              width: 18,
              height: 18,
              borderRadius: 9,
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <IconSvg type="icona-you1" style={{ color: '#fff', fontSize: 8 }} />
          </i>
        </div>
      </div>
    </Dropdown>
  )
})

export default CustomerService
